import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ScenarioBar from "../../components/ScenarioBar";
import { getScenarioNumByPath } from "../../utils/helpers";
import "../StartGame.css";
import "./ScenarioFlowStub.css";

const ACCENT = {
	2: "sfs--orange",
	3: "sfs--violet",
	4: "sfs--blue",
	5: "sfs--green",
};

/**
 * Pantalla mínima para rutas de contexto/quiz pendientes de storyboard.
 * @param {object} opts
 * @param {2|3|4|5} opts.scenarioNum
 * @param {"context"|"quiz"} opts.kind
 * @param {string} opts.label — título visible (ej. "Contexto 3")
 * @param {string} opts.nextRoute — destino del botón Continuar
 */
export function createScenarioStub({ scenarioNum, kind, label, nextRoute }) {
	const accentClass = ACCENT[scenarioNum] || "sfs--orange";

	return function ScenarioFlowStubPage() {
		const navigate = useNavigate();
		const location = useLocation();
		const activeScenario = getScenarioNumByPath(location.pathname);

		const kindLabel =
			kind === "quiz" ? "Pregunta (plantilla)" : "Contexto (plantilla)";

		return (
			<div className={`sfs-page ${accentClass}`}>
				<div className="sfs-inner">
					<span className="start-game-badge sfs-badge">
						<span className="start-game-badge-dot" aria-hidden />
						Escenario {scenarioNum} · borrador
					</span>
					<div className="sfs-card">
						<p className="sfs-kicker">{kindLabel}</p>
						<h1 className="sfs-title">{label}</h1>
						<p className="sfs-body">
							Este bloque está reservado para el guion definitivo de la dinámica.
							Aquí conectaremos textos, multimedia y enlaces con el resto del flujo
							cuando el storyboard esté cerrado.
						</p>
						<p className="sfs-note">
							{kind === "quiz"
								? "Los formatos de pregunta (test, arrastrar y soltar, completar frase, etc.) se montarán según cada escena."
								: "Los contextos narrativos y de apoyo clínico se sustituirán por el contenido final."}
						</p>
						<div className="sfs-actions">
							<button
								type="button"
								className="start-game-cta"
								onClick={() => navigate(nextRoute)}
							>
								Continuar
							</button>
						</div>
					</div>
				</div>
				<ScenarioBar activeScenario={activeScenario} />
			</div>
		);
	};
}
